<div class="components-list">
  @for (compCategory of compCategories; track compCategory) {
    @if (configMap[compCategory]) {
      <pub-component-editor
        [compCategory]="compCategory" [scheme]="configuration.scheme"
        [compConfig]="configMap[compCategory]">
      </pub-component-editor>
    }
  }
</div>
